import React, { useState } from "react";
import { Dialog, H3, Button, Tag, Label } from "@blueprintjs/core";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

import { withAuthentication } from "../Session";

const Container = styled.div`
  display: flex;
  align-items: stretch;
`;

const Aside = styled.div`
  flex: 0 0 300px;
  width: 300px;
  padding: 0 1rem;
  background-image: linear-gradient(hsl(240, 2%, 21%), hsl(240, 3%, 16%));
  border-right: 1px solid hsl(240, 2%, 29%);
`;

const Welcome = styled.div`
  padding: 1rem;
  padding-top: 0;
`;

const WelcomeTitle = styled.div`
  font-weight: 300;
  font-size: 1.2rem;
`;

const PanelSelect = styled.div`
  flex: 1;
  display: flex;
  padding: 1rem;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Panel = styled.div`
  flex: 1;
  border: 2px solid #137cbd;
  padding: 0.5rem;
  background: rgba(19, 124, 189, 0.2);
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 0.5rem;
`;

const Launcher = ({ authUser }) => {
  const [dialogOpen, setDialogOpen] = useState(true);
  return (
    <Dialog
      isOpen={dialogOpen}
      onClose={() => setDialogOpen(false)}
      style={{ paddingBottom: 0, overflow: "hidden", width: "700px" }}
    >
      <Container>
        <Aside>
          <img src="/icon@2x.png" height="267px" width="267px" alt="C3 logo" />
          <Welcome>
            <WelcomeTitle>Welcome to</WelcomeTitle>
            <H3>Complete Cloud Control</H3>
          </Welcome>
        </Aside>
        <PanelSelect>
          <div>
            <Label>My panels</Label>
            <Panel>
              DKC panel
              <Tag intent="primary" style={{ float: "right" }}>
                selected
              </Tag>
            </Panel>
            {authUser !== null ? (
              <p className="bp3-text-muted">
                No other panels linked to your account
              </p>
            ) : (
              <p className="bp3-text-muted">Sign in to view your panels</p>
            )}
          </div>
          <Buttons>
            {authUser !== null ? (
              <Button
                className="bp3-minimal"
                icon="person"
                text={authUser.email}
              />
            ) : (
              <Button disabled minimal text="Unauthenticated" icon="person" />
            )}
            <Button
              intent="primary"
              text="Continue to panel"
              onClick={() => setDialogOpen(false)}
            />
          </Buttons>
        </PanelSelect>
      </Container>
    </Dialog>
  );
};

export default withAuthentication(Launcher);
